import { onlyUnique } from '../../lib/helpers/ArrayHelper';

/**
 * The error codes a customer can actually clear from the contents/parcel editor, matched on substring so
 * both the ITEM-* and PRODUCT-* spellings of the same problem are covered.
 *
 * PARCEL is in the list for ITEM-PARCEL-EMPTY. It is raised only when a consignment is being validated, so
 * it never affects a row with no stored parcels, but ConsignmentSummary must keep reporting it - an empty
 * parcel is quoted by the API and then silently not booked, and the arranger behind "Fix Issues" is exactly
 * where the customer puts something in it.
 */
export const ErrorsCoveredByContentsSelection = (errors: string[]): string[] => {
  const partialErrorCodes = [
    'TARIFFCODE',
    'WEIGHT',
    'DIMENSIONS',
    'COUNTRYOFMANUFACTURE',
    'VALUE',
    'DESCRIPTION',
    'PARCEL'
  ];
  return errors.filter((error) => partialErrorCodes.some((c) => error.includes(c))).filter(onlyUnique);
};
